import React, { Fragment } from 'react';
import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';
import Head from '../../component/Page/Head';
import SecBlog from '../../component/Page/SecBlog';
import SecBanner from '../../component/Page/SecBanner';

const Planes = () => {
  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="bg__blue-2">
          <Navbar />
          <Head title="Nuestros Planes" />
        </div>
        <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />

        {/* Componente de planes Mensual / Anual */}
        <SecBlog title="Elige tu plan" />

        <SecBanner />

        <Footer />
      </div>
    </Fragment>
  );
};

export default Planes;
